import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';
import hashtag from '@assets/images/zaslouzisivic.webp';
import socialMediaDog from '@assets/images/social-media-dog.webp';



const SocialMedia = () => {
	const { t } = useTranslation([ 'web', 'links' ]);

	return (
		<div className='component-social-media'>

			<h2>{t('components.socialMedia.header')}</h2>

			<p>{t('components.socialMedia.text')}</p>

			<div className='social-media-icons'>
				<Link to={t('socialMedia.facebook', { ns: 'links' })} className='disable-selection' target='_blank'>
					<img src={facebookIcon} alt='social-media-facebook' />
				</Link>

				<Link to={t('socialMedia.instagram', { ns: 'links' })} className='disable-selection' target='_blank'>
					<img src={instagramIcon} alt='social-media-instagram' />
				</Link>
			</div>

			<div className='social-media-photo'>
				<img src={socialMediaDog} alt='social-media-photo' />	
			</div>

			<div className='social-media-hashtag'>
				<img src={hashtag} alt='social-media-hashtag' />	
			</div>

		</div>
	);
};

export default SocialMedia;